<template>
  <div>
    <notification
      :items="elements"
      :readonly="readonly"
      :loading="loading"
      @post="sendMessage"
      @delete-item="onDeleteItem"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { EventBus } from '@/event-bus';
import Listable from '@/components/mixins/listable';
import Notification from './Notifications';

export default {
  name: 'NotificationsContainer',
  components: { Notification },
  mixins: [Listable],
  props: {
    readonly: {
      type: Boolean,
      default: false,
    },
    source: {
      type: String,
      default: 'messages',
    },
    mode: {
      type: String,
      default: 'loadMore',
    },
  },
  methods: {
    ...mapActions('messages', ['newItem', 'deleteItem']),
    sendMessage({ message, attachment }) {
      if (!message) {
        return;
      }
      this.newItem({ message, attachment }).then(() => {
        this.update();
      });
    },
    update() {
      this.$store.dispatch('messages/getAll', { quiet: true });
    },
    onDeleteItem(notificationPk) {
      // Show confirmation
      EventBus.$emit('confirm', {
        message: 'Are you sure you\'d like to delete this notification?',
        callback: (confirm) => {
          if (confirm) {
            this.deleteItem(notificationPk);
          }
        },
        positiveText: 'Delete',
      });
    },
  },
};
</script>

<style lang="scss" scoped>

::v-deep .base-widget__content.base-widget__content--condensed {
  padding-right: 0px !important;
}
</style>
